<template>
  <div>
    <el-form ref="form" :model="form" label-width="100px">
      <el-form-item label="标签名称" style="width:500px;">
        <el-input v-model="form.title" clearable placeholder="标签名称"></el-input>
      </el-form-item>
      <el-form-item label="是否推荐">
        <el-radio-group v-model="form.isOriginal">
          <el-radio label="0">否</el-radio>
          <el-radio label="1">是</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: "tag_form",
  data() {
    return {
      form: {
        title: "",
        isOriginal: "0"
      }
    };
  }
};
</script>

<style scoped>
</style>